import { render, staticRenderFns } from "./FullIndex.vue?vue&type=template&id=be048b64&scoped=true"
import script from "./FullIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./FullIndex.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FullIndex.vue?vue&type=style&index=0&id=be048b64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be048b64",
  null
  
)

export default component.exports